import {
    LegacyFilmPlayerBaseInfoContent,
    LegacyVideoPlayerBaseInfoContent,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export const getFilmContentId = (
    filmOrVideo: LegacyFilmPlayerBaseInfoContent | LegacyVideoPlayerBaseInfoContent
) => {
    if (
        (filmOrVideo.__typename === 'Film' || filmOrVideo.__typename === 'Video') &&
        filmOrVideo.filmContentId
    ) {
        return filmOrVideo.filmContentId;
    }

    return '';
};
